<template>
  <PrimaryCard class="tile">
    <div v-if="title" class="tile__header">
      <div> {{ title }} </div>
      <ButtonV02
        v-if="hasButton"
        rounded
        small
        :color="buttonColor"
        :whiteText="true"
        @click="dispatchAndEmit"
      >
        <Icon
          v-if="buttonIcon"
          color="white"
          small
          :style="iconStyles"
        >
          {{ buttonIcon }}
        </Icon>
        {{ buttonText }}
      </ButtonV02>
    </div>
    <div class="tile__content">
      <slot></slot>
    </div>
  </PrimaryCard>
</template>

<script>
import { ButtonV02, Icon, PrimaryCard } from '@mikmak/components';
import eventDispatcher from '../../../events/dispatch';

export default {
  components: {
    ButtonV02,
    Icon,
    PrimaryCard,
  },
  props: {
    buttonColor: {
      type: String,
      default: '#223448',
    },
    buttonIcon: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasButton() {
      return this.buttonIcon || this.buttonText;
    },
    iconStyles() {
      return this.buttonText ? 'margin-right: 10px;' : '';
    },
  },
  methods: {
    dispatchAndEmit() {
      eventDispatcher(
        'dataTileButtonClick',
        { link_name: this.title },
      );

      this.$emit('click');
    },
  },
};

</script>

<style scoped>
.tile {
  margin: 16px;
}

.tile__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 16px;
}

.tile__content {
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  grid-gap: 16px;
}
</style>
